import React, { Component } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import apiCall from '../../utils/apiCall';
import { toast } from 'react-toastify';
import HeaderNav from '../common/HeaderNav';
// import { alpha } from '@mui/material/styles';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link className="copyright-link" color="inherit" href="/home">
        vipnumberstudio.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme({
  palette:{
    secondary:{
      main:"#000040"
    }
  }
});


class ForgotPassword extends Component {
  state = {
    registrationSuccess: false,
    isOTPSend : false,
    OTP : "",
    userInfo : "",
    isOTPVerified : false,
  }


  render() {

    const handleSubmit = async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const input = {
        email: data.get('email'),
        OTP: data.get('OTP'),
        password: data.get('password'),
        confirm_password: data.get('confirm_password'),
      }

      if ( !this.state.isOTPSend && (!input.email || (! /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.email))) ){
        toast.error("Email is required and must be valid email");
        return
      }

      if (!this.state.isOTPSend){
        const { result } = await apiCall('REACT_APP_SEND_OTP_TO_USER', 'POST', {
          email: input.email,
        })

        if (result && result['success'] && result['status']) {
          let OTP = result['status'].OTP;
          let userInfo = result['status'].userInfo.data;
          this.setState({OTP, userInfo, isOTPSend : true})
          toast.success("OTP Send Successfully");
        }
        return
      }

      if ( this.state.isOTPSend && !this.state.isOTPVerified ){

        if ( !input.OTP ){
          toast.error("OTP is required and must be a number");
          return;
        }
        if ( input.OTP && input.OTP.length && (input.OTP.length < 6 || input.OTP.length > 6) ){
          toast.error("OTP must be a 6 digit");
          return;
        }
        let OTP = this.state.OTP;
        if (OTP != input.OTP){
          toast.error("INCORRECT OTP");
        } else {
          this.setState({isOTPVerified : true});
        }
        return;
      }

      if ( this.state.isOTPSend && this.state.isOTPVerified ){
        const { result } = await apiCall('REACT_APP_UPDATE_PASSWORD', 'POST', {
          userId : this.state.userInfo.id,
          password: input.password,
          confirm_password: input.confirm_password,
          passwordResetOtpVerified : true,
        })
        if (result && result['success'] && result['status']) {
          toast.success("Successfully reset the password");
          setTimeout(() => {
            window.location.href = '/login'
          }, 400);
        }
      }

    };


    return (

      <React.Fragment>
        <HeaderNav activeTabName="signUp" />
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 10,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: '#000040' }}>
                {<LockOutlinedIcon />}
              </Avatar>
              <Typography component="h1" variant="h5">
                {'Forgot Password'}
              </Typography>
              <Typography
                style={{
                  display: (this.state.isOTPSend && !this.state.isOTPVerified) ? '' : 'none',
                  marginTop: '20px'
                }}
                component="h3"
              >
                OTP has been send on your registered Email !!
              </Typography>
              <Typography
                style={{
                  display: (this.state.isOTPSend && this.state.isOTPVerified) ? '' : 'none',
                  marginTop: '20px'
                }}
                component="h3"
              >
                OTP is verified, Kindly update the paasword !!
              </Typography>
              <Box
                style={{
                  display: (this.state.registrationSuccess) ? 'none' : '',
                }}
                component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}
              >
                {
                    this.state.isOTPSend
                  ? this.state.isOTPVerified
                  ? <Grid>
                      <TextField
                        color="secondary"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        size='small'
                      />
                      <TextField
                        color="secondary"
                        margin="normal"
                        required
                        fullWidth
                        name="confirm_password"
                        label="confirm_password"
                        type="password"
                        id="confirm_password"
                        autoComplete="current-password"
                        size='small'
                      />
                    </Grid>
                  : <TextField
                      color="secondary"
                      margin="normal"
                      required
                      fullWidth
                      name="OTP"
                      label="OTP (One Time Password)"
                      type="number"
                      id="OTP"
                      autoComplete="OTP"
                      size='small'
                    />
                  : <TextField
                      color="secondary"
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      size='small'
                    />
                }
                <Button
                  className='signup-btn'
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, bgcolor: "#000040" }}
                >
                  {
                    this.state.isOTPSend ? this.state.isOTPVerified ? "Change Password" : "Verify OTP" : "Send OTP"
                  }
                </Button>
                <Grid
                  style={{
                    display : (this.state.isOTPSend && !this.state.isOTPVerified) ? "" : "none",
                    justifyContent: 'center',
                    marginBottom : '12px'
                  }}
                  container
                >
                  <Grid item>
                    <Link className="signup-links" href="/forgotPassword" variant="body2">
                      Retry / Resend OTP
                    </Link>
                  </Grid>
                </Grid>
                <Grid
                  style={{
                    justifyContent: 'center'
                  }}
                  container
                >
                  <Grid item>
                    <Link className="signup-links" href="/login" variant="body2">
                      Remember Password? Log In
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Copyright sx={{ mt: 2, mb: 2 }} />
          </Container>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}

export default ForgotPassword;